import base from '../base';
import { getRequest, postJsonRequest } from '@/util/http';

const APPLY = {
  // 获取应用key
  getApplyKey(params) {
    return getRequest(`${base.baseUrl}/apply/get_apply_key`, params);
  },
  // 获取公司下所有应用
  getAllApply(params) {
    return getRequest(`${base.baseUrl}/apply/get_apply_list`, params);
  },
  // 新建应用
  createApply(params) {
    return postJsonRequest(`${base.baseUrl}/apply/save_pay_apply`, params);
  },
  // 修改应用
  updateApply(params) {
    return postJsonRequest(`${base.baseUrl}/apply/update_pay_apply`, params);
  },
  // 查询应用信息
  getPayApply(params) {
    return getRequest(`${base.baseUrl}/apply/get_pay_apply`, params);
  },
};

export default APPLY;
